export const objectiveLevelsOptions = {
	individual: 'bb0b22d1-cf13-4eb9-ab54-86fda2206787',
	team: 'bb0b22d1-cf13-4eb9-ab54-86fda22067871',
	company: 'bb0b22d1-cf13-4eb9-ab54-86fda22067872',
};
